import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ReferenceField, TextField } from "react-admin";

const DegreeField = () => {
  return (
    <ReferenceField
      source="degreeId"
      emptyText="-"
      reference={administrationRequests.getDegreesSelect()}
    >
      <TextField source="name" />
    </ReferenceField>
  );
};

export default DegreeField;
